export const DAYS_OF_THE_WEEK = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const PUBLIC_HOLIDAYS = ['goodFriday', 'anzacDay', 'christmasDay'];

export const PublicHolidayNames = {
  goodFriday: 'Good Friday',
  anzacDay: 'Anzac Day',
  christmasDay: 'Christmas Day',
};
